import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Box, Stack } from "@mui/material";
import { ArrowBackIosNewOutlined as ArrowBackIosNewOutlinedIcon } from "@mui/icons-material";
import { BACK, FOOTER_CONTATTI } from "../../../modules/language";
import { fetchContactsEnded, getContacts } from "../../../modules/prontoSoccorso";
import { getMessageString } from "../../../utility";
import { Icona, LoadingSpinner } from "../../shared";

export const Contatti = injectIntl(({ intl }) => {
  const navigate = useNavigate();
  const contacts = useSelector(getContacts);
  const fetchEnded = useSelector(fetchContactsEnded);

  return (
    <Box className="contatti">
      <Button startIcon={<ArrowBackIosNewOutlinedIcon />} onClick={() => navigate(-1)}>
        {getMessageString(intl, BACK)}
      </Button>
      <Stack className="pageTitle">
        <Icona tipologia="email" />
        <Typography variant="h2">{getMessageString(intl, FOOTER_CONTATTI)}</Typography>
      </Stack>
      {contacts && <div dangerouslySetInnerHTML={{ __html: contacts }} />}
      <LoadingSpinner loading={!fetchEnded} />
    </Box>
  );
});
